module.exports = __webpack_public_path__ + "static/okBusinessControl-8594550ac3dac68da0c4dc99eb15259c.png";